module.exports = __webpack_public_path__ + "static/scholor-0d815217c5a3aacd669bda2589385472.png";